import { ClientSecurityData } from './api-context';
import { Client } from './client';

let client: Client<ClientSecurityData>;

export function getBackendApi() {
  if (!client) {
    client = new Client<ClientSecurityData>({
      baseUrl: process.env['NEXT_PUBLIC_API_URL'],
      baseApiParams: {
        secure: true,
      },
      securityWorker: (data) => {
        const headers: Record<string, string> = {};

        if (data?.token) {
          headers['Authorization'] = `Bearer ${data.token}`;
        }

        return {
          headers,
        };
      },
    });
  }

  return client;
}
